import { Link, useLocation } from 'react-router-dom';
import {
  LayoutDashboard, Truck, CalendarDays, FileText,
  Target, Users, Trophy, Settings, X,
} from 'lucide-react';
import { clsx } from 'clsx';

const NAV_ITEMS = [
  { path: '/', label: 'Inicio', icon: LayoutDashboard },
  { path: '/vehicles', label: 'Vehículos', icon: Truck },
  { path: '/availability', label: 'Disponibilidad', icon: CalendarDays },
  { path: '/documents', label: 'Documentos', icon: FileText },
  { path: '/opportunities', label: 'Oportunidades', icon: Target },
  { path: '/referrals', label: 'Referidos', icon: Users },
  { path: '/gamification', label: 'Logros', icon: Trophy },
  { path: '/settings', label: 'Configuración', icon: Settings },
];

interface MobileNavProps {
  isOpen: boolean;
  onClose: () => void;
}

export function MobileNav({ isOpen, onClose }: MobileNavProps) {
  const location = useLocation();

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 lg:hidden animate-fade-in">
      <div className="absolute inset-0 bg-black/50" onClick={onClose} />
      <nav className="absolute top-0 left-0 bottom-0 w-72 bg-white shadow-xl animate-slide-up">
        <div className="flex items-center justify-between px-4 py-4 border-b border-gray-100">
          <img src="/images/logo-full-black.png" alt="PartRunner" className="h-7" />
          <button onClick={onClose} className="p-1 hover:bg-gray-100 rounded-lg">
            <X size={20} />
          </button>
        </div>

        <div className="px-3 py-4 space-y-1">
          {NAV_ITEMS.map(({ path, label, icon: Icon }) => {
            const isActive = path === '/' ? location.pathname === '/' : location.pathname.startsWith(path);
            return (
              <Link
                key={path}
                to={path}
                onClick={onClose}
                className={clsx(
                  'flex items-center gap-3 px-3 py-3 rounded-xl text-sm font-medium transition-all duration-200',
                  isActive
                    ? 'bg-brand-yellow text-brand-black'
                    : 'text-gray-600 hover:bg-gray-50'
                )}
              >
                <Icon size={20} />
                {label}
              </Link>
            );
          })}
        </div>
      </nav>
    </div>
  );
}
